import { render, staticRenderFns } from "./teacherAttendance.vue?vue&type=template&id=3272de52&"
import script from "./teacherAttendance.vue?vue&type=script&lang=js&"
export * from "./teacherAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports